import { render, staticRenderFns } from "./PaidCustodyCancel.vue?vue&type=template&id=2eefe1a8&scoped=true"
import script from "./PaidCustodyCancel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaidCustodyCancel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PaidCustodyCancel.vue?vue&type=style&index=0&id=2eefe1a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eefe1a8",
  null
  
)

export default component.exports